import { InjectionKey } from "vue";

export const componentSelectorPrefixInjectionKey = Symbol() as InjectionKey<string>;
export const CHANNEL_SETTINGS_SYMBOL = Symbol("channelSettings");
export const CHANNEL_PROVIDE_SYMBOL = Symbol("valuesource");
